import * as types from './mutations-types'
import {DOWNLOAD_FILE} from '../../../../../common/utils/uploadFileUtil'

export default {
  [types.POINTS_MAIL_LIST] (state, data) {
    let codeToFileIds = data.dataList
    if (codeToFileIds) {
      codeToFileIds.filter((item, index) => {
        let imgList = []
        if (item.codeToFileIds && item.codeToFileIds.showOff) {
          item.codeToFileIds.showOff.filter((itemTwo, indexTwo) => {
            let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
            imgList.push(img)
          })
        }
        item.codeToFileIds.showOff = imgList
      })
    }
    state.pointsMailList = data.dataList
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/store/mutations.js